export default "__VITE_ASSET__C3b6cYUk__"